class TableIngredients extends HTMLElement {
  connectedCallback() {
    if (this.dataset.formatted === 'true') return;

    const lines = getLinesFromParagraphs(this);

    if (!lines.some((line) => line.includes(';'))) return;

    const table = document.createElement('table');
    table.className = 'text-block__ingredients-table';
    table.setAttribute('role', 'presentation');

    for (const line of lines) {
      const { label, value } = splitLine(line);
      const row = document.createElement('tr');
      row.className = 'text-block__ingredients-row';

      const labelCell = document.createElement('td');
      labelCell.className = 'text-block__ingredients-label';
      labelCell.textContent = label;
      row.append(labelCell);

      if (value) {
        const valueCell = document.createElement('td');
        valueCell.className = 'text-block__ingredients-value';
        valueCell.textContent = value;
        row.append(valueCell);
      } else {
        labelCell.colSpan = 2;
      }

      table.append(row);
    }

    this.replaceChildren(table);
    this.dataset.formatted = 'true';
  }
}

const getLinesFromParagraphs = (element) => {
  const paragraphs = Array.from(element.querySelectorAll('p'));

  if (paragraphs.length) {
    return paragraphs
      .flatMap((paragraph) => paragraph.textContent.split(/\r?\n/))
      .map((line) => normalizeLine(line))
      .filter(Boolean);
  }

  return element.textContent
    .split(/\r?\n/)
    .map((line) => normalizeLine(line))
    .filter(Boolean);
};

const normalizeLine = (line) => line.replace(/\u00A0/g, ' ').trim();

const splitLine = (line) => {
  const separatorIndex = line.lastIndexOf(';');

  if (separatorIndex === -1) {
    return { label: line, value: '' };
  }

  return {
    label: line.slice(0, separatorIndex).trim(),
    value: line.slice(separatorIndex + 1).trim(),
  };
};

if (!customElements.get('table-ingredients')) {
  customElements.define('table-ingredients', TableIngredients);
}
